import { DatePipe } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { SwpppPublicReport, SwpppQuestion } from '../../shared'
import { Services } from '../../shared/services'

@Component({
    selector: 'app-swppp-public-report',
    templateUrl: './swppp-public-report.component.html',
    standalone: true,
    imports: [DatePipe],
})
export class SwpppPublicReportComponent implements OnInit {
    report?: SwpppPublicReport
    missing = false

    constructor(
        private route: ActivatedRoute,
        private services: Services,
    ) {}

    ngOnInit() {
        const token = this.route.snapshot.paramMap.get('token')
        this.services.data.get<SwpppPublicReport>('/api/SwpppPublic/GetReport?token=' + token).subscribe({
            next: report => (this.report = report),
            error: () => (this.missing = true),
        })
    }

    value(question: SwpppQuestion) {
        const answer = this.report?.answers?.find(item => item.questionId === question.id)
        const other = answer?.otherText ? ' ' + answer.otherText : ''
        return ((answer?.value || '').replaceAll('|', ', ') || '—') + other
    }

    imageUrl(image: { id: string; extension: string }) {
        return './Resources/Images/SwpppInspection/' + this.report?.inspection?.id + '/' + image.id + image.extension
    }
}
